import { fetcher } from "helpers/fetcher";

import { TGetStaffInsuranceReq, TGetStaffInsuranceRes } from "./types";
import { API_HEADER } from "../constants";
import { ENDPOINT } from "../endpoint";

export const getEmployeeInsurance = async (payload: TGetStaffInsuranceReq) => {
  return await fetcher<TGetStaffInsuranceRes, TGetStaffInsuranceReq["data"]>(
    ENDPOINT.USER.GET_EMPLOYEE_INSURANCE,
    {
      data: payload.data,
      headers: {
        [API_HEADER.VERSION]: ENDPOINT.USER.GET_EMPLOYEE_INSURANCE.version,
        [API_HEADER.USER_ID]: payload.idUser,
      },
    }
  );
};

export const queryGetEmployeeInsurance = async (
  payload: TGetStaffInsuranceReq
) => {
  return (await getEmployeeInsurance(payload)).data;
};

queryGetEmployeeInsurance._key = (payload: TGetStaffInsuranceReq) => [
  ENDPOINT.USER.GET_EMPLOYEE_INSURANCE.url,
  payload,
];
